import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PhysicalCardsComponent } from './physical-cards/physical-cards.component';
import { AuthGuard } from '../../../../shared/_guards/auth.guard';
import { PhysicalCardsListComponent } from './physical-cards-list/physical-cards-list.component';

const routes: Routes = [
  {
    path: 'physical-cards', component: PhysicalCardsComponent, canActivate: [AuthGuard],
    children: [
      { path: '', pathMatch: 'full', component: PhysicalCardsListComponent, canActivate: [AuthGuard] }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PhysicalCardsRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/physical-cards/physical-cards-routing.module.ts